import { makeStyles } from '@material-ui/core';

export default makeStyles(
  () => ({
    dateInputWrap: {
      marginLeft: '16px',
      marginRight: '32px',
    },
  }),
  { name: 'ReportPopup' },
);
